import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

class TableRow extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || this.props.isSelected !== nextProps.isSelected
  }

  render() {
    const { columns, onRowClick, isSelected, data } = this.props

    if (data.isHeader) {
      return (
        <tr key={data.title} className="row table-group_header">
          <td className="cell" colSpan={columns.length}>
            {this.props.t(data.titleKey)}
          </td>
        </tr>
      )
    }

    const onClick = onRowClick ? () => onRowClick(data) : undefined

    // add `data` as an object to <CellRender /> as then it can be used/compared as a whole object
    return (
      <tr onClick={onClick} className={classNames('row', { selected: isSelected })}>
        {columns.map(({ key: cellKey, CellRender }) => (
          <td key={cellKey} className={`cell cell-${cellKey}`}>
            {CellRender ? <CellRender {...data} data={data} /> : data[cellKey]}
          </td>
        ))}
      </tr>
    )
  }
}

TableRow.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      CellRender: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
      ColumnRender: PropTypes.func,
      key: PropTypes.string.isRequired,
      subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    }),
  ),
  data: PropTypes.object,
  isSelected: PropTypes.bool,
  onRowClick: PropTypes.func,
}

export default withTranslation()(TableRow)
